import { datadogRum } from '@datadog/browser-rum';
import config from '@/config';
import { devWarning } from '@/helpers/dev';

const isEnabled = !!config.datadogApplicationId;

const SENSITIVE_INPUT_KEYS = [
  'currentPassword',
  'password',
  'passwordConfirmation',
] as const;

function sanitizeInputForLogging(input: unknown): unknown {
  if (input === null || typeof input !== 'object') {
    return input;
  }
  const copy = { ...(input as Record<string, unknown>) };
  for (const key of SENSITIVE_INPUT_KEYS) {
    if (key in copy) {
      copy[key] = '[REDACTED]';
    }
  }
  return copy;
}

export const captureException = (e: any, options: any) => {
  // When disabled, rethrow exception so that tests will pick it up
  isEnabled
    ? datadogRum.addError(e, options)
    : () => {
        throw e;
      };
};

export const handledException = (e: any, options: any) => {
  // Eventually these should not got to an error tracker
  // or be identified as handled as they are expected and can happen
  isEnabled ? datadogRum.addError(e, options) : devWarning(e);
};

export const logValidationError = (
  operationName: string,
  errors: any,
  input?: any,
) => {
  handledException(new Error('Backend validation error'), {
    operationName,
    errors,
    input: input !== undefined ? sanitizeInputForLogging(input) : input,
  });
};
